import { type ReactNode } from 'react'
import { Checkbox } from '@/components/Checkbox'
import {
  ClickableTable,
  ClickableTableBody,
  ClickableTableHead,
  ClickableTableHeader,
} from '@/components/Table/ClickableTable'
import { match } from '@/utils/pattern-match-util'
import { type ColumnId } from './applicant-management-table-columns'
import styles from './ApplicantManagementTable.module.css'

export interface ApplicantManagementTableColumn {
  id: ColumnId
  header: string
  align: 'left' | 'center' | 'right'
}

export interface ApplicantManagementTableProps {
  columns: ApplicantManagementTableColumn[]
  postingId?: string
  allSelectedState: boolean | 'indeterminate'
  onToggleAll: () => void
  /**
   * An `ApplicantManagementTableRow` per applicant.
   */
  children?: ReactNode
}

export function ApplicantManagementTable({
  columns,
  postingId,
  allSelectedState,
  onToggleAll,
  children,
}: ApplicantManagementTableProps) {
  return (
    <ClickableTable striped>
      <ClickableTableHead>
        {columns.map((column) =>
          column.id === 'Checkbox' ? (
            <ClickableTableHeader
              key={column.id}
              className={columnClassName(column.id)}
              alignment={column.align}
            >
              <Checkbox
                onChange={onToggleAll}
                checked={allSelectedState}
                testId={`applicant-manager-select-all-${postingId}`}
              />
            </ClickableTableHeader>
          ) : (
            <ClickableTableHeader
              key={column.id}
              className={columnClassName(column.id)}
              alignment={column.align}
            >
              {column.header}
            </ClickableTableHeader>
          ),
        )}
      </ClickableTableHead>
      <ClickableTableBody>{children}</ClickableTableBody>
    </ClickableTable>
  )
}

function columnClassName(id: ColumnId) {
  return match(id, {
    Checkbox: styles.checkboxColumn,
    Applicant: styles.applicantColumn,
    Type: styles.proTypeColumn,
    Location: styles.locationColumn,
    Experience: styles.experienceColumn,
    TotalWorkspaces: styles.totalWorkspacesColumn,
    ContactOwner: styles.contactOwnerColumn,
    Status: styles.statusColumn,
    Action: styles.actionColumn,
  })
}
